import React, { useEffect, useState } from 'react'
import { Card, Grid } from '@mui/material'
import { RouteComponentProps, useLocation } from 'react-router-dom'
import { ClassNameMap, makeStyles } from '@mui/styles'
import { RootState, useAppThunkDispatch } from '../../redux/store'
import { useSelector } from 'react-redux'
import FiltersComponent from './landing/filters.component'
import { getMetaData } from '../../redux/meta-data-slice'
import PatientDataTableComponent from './landing/patientDataTable-demo.component'
import ClinicVisitDataTableComponent from './landing/clinicVisitDataTable.component'
import { setClinicVisitsTable } from '../../redux/common-data-slice'

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#f8f8f8',
    borderRadius: '0px',
  },
}))

interface IProps extends RouteComponentProps {}

const PatientListComponent: React.FC<IProps> = () => {
  const classes: ClassNameMap = useStyles()
  const dispatch = useAppThunkDispatch()
  const selectedStage = useSelector(
    (state: RootState) => state.commonData.selectedStage
  )
  const patientsTable = useSelector(
    (state: RootState) => state.commonData.patientsTable
  )
  const clinicVisitsTable = useSelector(
    (state: RootState) => state.commonData.clinicVisitsTable
  )

  const url = useLocation()
  const isClinicVisits = url.pathname === '/clinic-visits'

  const [, setFilteredType] = useState('')
  const [filterList, setFiletrList] = useState([] as any)

  // Patient list preserves state, clinic visits always starts fresh
  useEffect(() => {
    if (isClinicVisits) {
      // Always reset clinic visits to default state (no preservation)
      dispatch(
        setClinicVisitsTable({
          limit: 50,
          page: 1,
          sort: '',
          search: '',
          programs: '',
          hospitals: '',
          status: '',
          gender: '',
          stage: '',
          state: '',
          priority: '',
          inactive: 'false',
          activity_days: '',
          clinic_visit_days: '',
          approval_status: 'false',
          clinic_visit_status: '',
          cardiologist: '',
          isSubmit: '',
          shouldRestoreState: 'false',
          preserveData: '',
          scrollPosition: 0,
        })
      )
    }
  }, [isClinicVisits, url.pathname, dispatch])

  useEffect(() => {
    if (selectedStage) {
      setFilteredType(selectedStage)
    }

    dispatch(getMetaData()).then((response: any) => {
      getFilterList(response?.payload?.data?.PATIENT_STAGE || [])
    })

    getFilterList([])
  }, [])

  const getFilterList = (list: any) => {
    let filterItem = {} as any
    filterItem['ENROLLMENT'] = list['ENROLLMENT']
    filterItem['DATA_INTAKE'] = list['DATA_INTAKE']
    filterItem['MED_BASELINE'] = list['MED_BASELINE']
    filterItem['MED_INITIATION'] = list['MED_INITIATION']
    filterItem['EARLY_TOX_CHECK'] = list['EARLY_TOX_CHECK']
    filterItem['MED_EVALUATION'] = list['MED_EVALUATION']
    filterItem['PROGRAM_EVALUATION'] = list['PROGRAM_EVALUATION']
    filterItem['TOXICITY_MONITORING'] = list['TOXICITY_MONITORING']
    filterItem['MAINTENANCE_SURVEILLANCE'] = list['MAINTENANCE_SURVEILLANCE']

    setFiletrList(filterItem)
  }

  return (
    <section className="questionnaire-wrapper">
      <Card variant="outlined" className={classes.root}>
        <Grid container spacing={0} direction="row">
          <Grid item sm={2}>
            <FiltersComponent filterList={filterList} />
          </Grid>
          <Grid item sm={10} sx={{ width: '14rem' }}>
            {isClinicVisits ? (
              <ClinicVisitDataTableComponent
                clinicVisitsTable={clinicVisitsTable}
              />
            ) : (
              <PatientDataTableComponent patientsTable={patientsTable} />
            )}
          </Grid>
        </Grid>
      </Card>
    </section>
  )
}

export default PatientListComponent
